import { create } from 'zustand';
import { api } from '@/lib/api';
import type { School } from '@nzassa/shared';

interface SchoolState {
  school: School | null;
  loaded: boolean;
  fetchSchool: (schoolId: string) => Promise<void>;
}

export const useSchoolStore = create<SchoolState>((set) => ({
  school: null,
  loaded: false,

  fetchSchool: async (schoolId: string) => {
    try {
      const res = await api.get<{ school: School }>(`/schools/${schoolId}`);
      set({ school: res.school, loaded: true });
    } catch {
      set({ loaded: true });
    }
  },
}));
